import React from 'react'
import styled from '@emotion/styled'
import Layout from '../components/layout'
import LinkButton from '../components/LinkButton'
import SEO from '../components/seo'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;
`

const ContentWrapper = styled.div`
  margin-top: 70px;
  text-align: center;
  width: 100%;
`

const Image = styled.img`
  margin: 50px auto 0 auto;
  height: 40vh;
  max-height: 360px;
`

const ImageCredit = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  width: 100%;
`

const ImageCreditContent = styled.div`
  font-size: 12px;
  margin: 3em auto 1em auto;
  text-align: center;
`

const NotFoundPage = () => (
  <>
    <SEO title="404: Not Found" />
    <Layout>
      <Wrapper>
        <ContentWrapper>
          <Image
            src="https://res.cloudinary.com/ds2a4tgsk/image/upload/v1563291313/images/taken.svg"
            width="420"
            alt="Ghost taken"
          />
          <h1 style={{ margin: '20px 0' }}>Error (404)</h1>
          <p style={{ margin: '20px 0' }}>
            We can&apos;t find the page you&apos;re looking for.
          </p>
          <LinkButton type="primary" to="/">
            Go back home
          </LinkButton>
        </ContentWrapper>
        <ImageCredit>
          <ImageCreditContent>
            <span role="img" aria-label="heart">
              💙
            </span>{' '}
            open-source illustration by <a href="https://undraw.co">unDraw</a>
          </ImageCreditContent>
        </ImageCredit>
      </Wrapper>
    </Layout>
  </>
)

export default NotFoundPage
